import {ImageProps} from 'material-ui-image/lib/components/Image/Image';
import React from 'react';
import {FileItemContainer} from '../../base-components/StudioDataset/FileViewer/FileContainer';
import {ImageItem} from '../../base-components/StudioDataset/FileViewer/ImageItem';
import {RendererProps} from '../../base-components/StudioDataset/Renderer';
import {getThumbSize} from '../../base-components/StudioDataset/StudioDatasetViewer';
import {AnnotatedImage} from './ImagePreview';

export const ThumbnailGridClassificationRenderer = ({
  url,
  selected = false,
  view,
  item,
  isBusy = false,
  overlayElement,
  onSelect = () => {},
  onClick = () => {},
}: RendererProps) => {
  const thumbSize = getThumbSize(view, selected);

  const onImageClick: ImageProps['onClick'] = event => {
    event.preventDefault();
    event.stopPropagation();
    onClick(item, event);
  };

  return (
    <FileItemContainer
      key={item.id}
      selected={selected}
      onSelect={() => onSelect(item)}
      onClick={onImageClick}
      showSelection={true}
      className="default"
      overlayElement={overlayElement}
    >
      <ImageItem url={url} height={thumbSize} width={thumbSize} isBusy={isBusy} />
    </FileItemContainer>
  );
};

export const ThumbnailGridDetectionRenderer = ({
  url,
  selected = false,
  view,
  item,
  isBusy = false,
  overlayElement,
  onSelect = () => {},
  onClick = () => {},
}: RendererProps) => {
  const thumbSize = getThumbSize(view, selected);

  const onImageClick: ImageProps['onClick'] = event => {
    event.preventDefault();
    event.stopPropagation();
    onClick(item, event);
  };

  return (
    <FileItemContainer
      key={item.id}
      selected={selected}
      onSelect={() => onSelect(item)}
      onClick={onImageClick}
      showSelection={true}
      className="default"
      overlayElement={overlayElement}
    >
      <AnnotatedImage
        item={item}
        src={url?.toString() || ''}
        width={thumbSize}
        height={thumbSize}
        maxWidth={thumbSize}
        maxHeight={thumbSize}
      />
    </FileItemContainer>
  );
};
